import React, {FunctionComponent, useCallback, useEffect, useMemo, useState} from "react";
import UpsertPartSupportStatusDialog from "../../../../../components/dialogs/upsert-part-support-status";
import ChangeWarrantyRGAModal from "../../../../../components/dialogs/change-warranty-rga";
import AssignCreditToPartSupportRequestModal from "../../../../../components/dialogs/assign-credit-to-part-support-request";
import AssignVendorCreditToPartSupportRequestModal from "../../../../../components/dialogs/assign-vendor-credit-to-part-support-request";
import PartSupportVendorSelection from "../../../../../components/app-specific/part-support/part-support-vendor-selection";
import UpdatePartSupportRequestNoteModal from "../../../../../components/dialogs/update-part-support-request-note";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import Api from "../../../../../../core/services/api/api";
import {DefaultPaginationInfo, WarrantyAndReturnRequestStatuses} from "../../../../../../core/constants/enums";
import AddPartSupportRequestDialog, {AddPartSupportRequestProcessSteps} from "../../../../../components/dialogs/upsert-part-support-request/add";
import {routeFunctions} from "../../../../../../core/models/static/routes/app-routes";
import ToastService from "../../../../../../core/services/toast";
import VendorInformationModal from "../../../../../components/dialogs/vendor-information";
import {dataGridCellTextProps, DataGridColumn, DataGridColumnAlignments, DataGridColumnTypes, DataGridRow, GetExportInfoFunc, useDataGridSavedState} from "../../../../../../packages/data-grid";
import useDynamicColumns from "../../../../../hooks/use-dynamic-columns";
import ApiResponseDs from "../../../../../../core/services/api/type-declerations/response";
import useSearch, {SearchDataSettings, SearchDataSettingsPaginationInfo, UseSearchFunction, UseSearchFunctionArg} from "../../../../../hooks/use-search";
import QueryBuilder, {QueryBuilderUtils} from "../../../../../../packages/query-builder";
import LoadingLottieAnimation from "../../../../../components/app-specific/lottie-animations/loading";
import PartnerDataGrid from "../../../../../containers/data-grid";
import {Box, CircularProgress, SvgIcon, Tooltip, Typography} from "@mui/material";
import {Add, Edit, InfoOutlined, OpenInNew} from "@mui/icons-material";
import Button from "../../../../../components/base/button/button";
import IconButton from "../../../../../components/base/button/icon_button";
// @ts-ignore
import {ReactComponent as Printer} from "../../../../../../assets/images/printer.svg";
// @ts-ignore
import {ReactComponent as Delete} from "../../../../../../assets/images/remove.svg";
// @ts-ignore
import {ReactComponent as Copy} from '../../../../../../assets/images/copy.svg'

import {Col} from "reactstrap";
import {Popover} from "../../../../../components/app-specific/popover";
import {createUUId} from "../../../../../../core/services/utils/utils";
import UpsertPartSupportVendorStatusDialog from "../../../../../components/dialogs/upsert-part-support-vendor-status";
import ChangePartSupportOperatorDialog from "../../../../../components/dialogs/change-part-support-operator";
import {useConfigureNotebook} from "../../../../../hooks/use-notebook-config";
import DateUtils from "../../../../../../core/services/date-utils";
import CopyToClipboard from "../../../../../components/base/copy-to-clipboard";
import useAccessLevels from "../../../../../hooks/use-access-levels";
import ProductInformationPopover from "../../../../../components/app-specific/draggable-popover/product-information-popover";
import {Link, useHistory} from "react-router-dom";
import useBehavioralAnalyticsTool from "../../../../../hooks/use-behavioural-analytics-tool";
import {useOperatorInformation} from "../../../../../hooks/use-operator-information";


type RequestListEntry = {
    id: number,
    rga: string,
    typeId: number,
    type: string,
    creditNo: string,
    creditId: number,
    customerName: string,
    customerId: number,
    failedDate: string,
    failedMileage: number,
    installedDate: string,
    installedMileage: number,
    internalNote: string,
    invoiceNo: string,
    lastModifiedDateTime: string,
    modelId?: number,
    modelTitle?: string,
    makeId?: number,
    make?: string,
    note: string,
    operatorId: string,
    operatorFirstname: string,
    operatorLastname: string,
    partId?: number,
    partNo: string,
    serialNo: string,
    statusId: number,
    vendorStatusId: number,
    vendorStatus: string,
    vendorStatusReasonId: number,
    vendorStatusReason: string,
    status: string,
    changeStatusReasonId: number,
    reasonTitle: string,
    submitDateTime: string,
    unSeriliazablePartsCount: number,
    vendorId: number,
    vendorName: string,
    vendorEmail: string,
    vendorPhone: string,
    vendorCode: string,
    vendorAccessLink: string,
    vendorCreditNumber?: string,
    vendorCreditId?: number,
    vin: string,
    warehouseCode: string,
    accepting?: boolean,
    removingVendor?: boolean,
    removingCredit?: boolean,
    removingVendorCredit?: boolean,
};

interface Status {
    id: number;
    title: string;
}

interface StatusReason {
    id: number;
    title: string;
    code: string,
}

interface NewVendorInfo {
    vendorInfo: {
        id: number;
        name: string;
        email: string;
        phone: string;
        code: string;
    },
    vendorAccessLink: string,
}

type OldRequestListEntry = DeepPartial<{
    "warehouseCode": string,
    "creditId": number,
    "vendor": {
        "id": number,
        "name": string,
        "email": string,
        "phone": string,
        "code": string
    },
    "vendorAccessLink": string,
    "vendorCreditId": number,
    "vendorCreditNumber": string,
    "partShareLink": {
        "id": number,
        "title": string,
        "token": string,
        "partId": number,
        "createdDate": string,
        "clickLimitCount": number,
        "expireDate": string,
        "clickedCount": number,
        "operator": {
            "id": string,
            "firstName": string,
            "lastName": string,
            "phone": string,
            "email": string,
            "isActive": boolean,
            "lastLoginDate": string
        },
        "shareLink": string,
    },
    "note": string,
    "partShareLinkAddress": string,
    "failedDate": string,
    "failedMileage": number,
    "installedDate": string,
    "installedMileage": number,
    "modelId": number,
    "makeId": number,
    "vin": string,
    "year": number,
    "internalNote": string,
    "type": string,
    "typeID": number,
    "imageSource": string,
    "description": string,
    "operator": {
        "id": string,
        "firstName": string,
        "lastName": string,
        "phone": string,
        "email": string,
        "isActive": boolean,
        "lastLoginDate": string
    },
    "customer": {
        "id": number,
        "name": string,
        "city": string,
        "phone": string,
        "code": string,
        "existInLocal": boolean,
        "creditLimit": number,
        "province": string,
        "address": string,
        "postalCode": string
    },
    "user": {
        "id": number,
        "email": string,
        "phone": string,
        "connectedToACustomer": boolean,
        "customer": {
            "id": number,
            "name": string,
            "city": string,
            "phone": string,
            "code": string,
            "existInLocal": boolean,
            "creditLimit": number,
            "province": string,
            "address": string,
            "postalCode": string
        },
        "firstName": string,
        "lastName": string,
    },
    "cover": {
        "id": number,
        "fileName": string,
        "isCover": boolean,
        "url": string,
        "content": string,
        "orderNumber": string,
        "isPlaceholder": boolean
    },
    "id": number,
    "rga": string,
    "status": string,
    "statusID": number,
    "partNo": string,
    "submitDateTime": string,
    "changeStatusReasonId": number,
    "statusChangeReason": {
        "id": number,
        "title": string,
        "reqStatusId": number,
        "code": string,
        "isActive": boolean
    },
    "lastModifiedDate": string,
    "creditNo": string,
    "invoiceNo": string,
    "serialNo": string,
    "unSeriliazablePartsCount": number
}> & {
    id: number
};

interface DialogSharedState {
    open: boolean;
    request: OldRequestListEntry | undefined;
}

const initAddPartSupportReqDialogState: DialogSharedState & {
    currentProcess: string | null
} = {open: false, request: undefined, currentProcess: null};
const initialAssignCredit: DialogSharedState = {open: false, request: undefined,}
const initialChangeOperator = {open: false, operator: undefined, requestId: undefined}
const initialAssignVendor: DialogSharedState & {
    onSelect: Function | undefined
} = {open: false, request: undefined, onSelect: undefined}
const initialAssignVendorCredit: DialogSharedState = {open: false, request: undefined}
const initialUpdateNote: DialogSharedState = {open: false, request: undefined}
const initialVendorInfo: DialogSharedState = {open: false, request: undefined}
const initialChangeStatus: DialogSharedState = {open: false, request: undefined}
const initialChangeRga: DialogSharedState = {open: false, request: undefined}
const initialChangeVendorStatus = {open: false, requestId: undefined, statusId: undefined}

const queryBuilderSaveName = 'NewPartSupportRequestListViewQueryBuilder';
const dynamicColumnsSectionName = 'PartSupportRequest';
const dataGridSaveConfig = {
    name: "NewPartSupportRequestListViewDataGrid",
    version: 2,
}

const staticColumnsNames = {
    remove: 'remove',
    navigate: 'navigate',
    print: 'print',
    accept: 'accept',
}

const knownColumnNames = {
    rga: 'rga',
    status: 'status',
    vendorStatus: 'vendorStatus',
    serialNo: 'serialNo',
    statusId: 'statusId',
    type: 'type',
    partNo: 'partNo',
    creditNo: 'creditNo',
    customerName: 'customerName',
    vendorCreditNumber: 'vendorCreditNumber',
    vendorName: 'vendorName',
    vendorCode: 'vendorCode',
    operatorFirstname: 'operatorFirstname',
    operatorLastname: 'operatorLastname',
    note: 'note',
    internalNote: 'internalNote',
}

const PartSupportRequestListView: FunctionComponent = () => {
    const operatorAccessLevels = useAccessLevels();
    const canExportPartSupportRequests = operatorAccessLevels.packages.warrantyAndReturn.exportPartSupportRequests;
    const history = useHistory()
    const [data, setData] = useState<RequestListEntry[]>([]);
    const [statuses, setStatuses] = useState<Status[]>([]);
    const [removing, setRemoving] = useState<Array<number>>([]);
    const [types, setTypes] = useState([]);
    const [statusesLoading, setStatusesLoading] = useState(true);
    const [addPartSupportReqDialogState, setAddPartSupportReqDialogState] = useState(initAddPartSupportReqDialogState)
    const [changeStatus, setChangeStatus] = useState(initialChangeStatus);
    const [changeVendorStatus, setChangeVendorStatus] = useState(initialChangeVendorStatus);
    const [changeRga, setChangeRga] = useState(initialChangeRga);
    const [assignCredit, setAssignCredit] = useState(initialAssignCredit);
    const [changeOperator, setChangeOperator] = useState(initialChangeOperator);
    const [assignVendor, setAssignVendor] = useState(initialAssignVendor);
    const [assignVendorCredit, setAssignVendorCredit] = useState(initialAssignVendorCredit);
    const [updateNote, setUpdateNote] = useState(initialUpdateNote);
    const [vendorInfo, setVendorInfo] = useState(initialVendorInfo);
    const isMounted = useIsMounted();

    const operatorInformation = useOperatorInformation();

    const {configureNotebookTags} = useConfigureNotebook('warranty-and-return-requests-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral tool for the view
     */
    useEffect(() => {
        configureNotebookTags((noteTags) => noteTags.warrantyAndReturnRequests);
        configureBehavioralTool((tool) => tool.warrantyAndReturnRequests);
    }, [configureBehavioralTool, configureNotebookTags]);


    const dataGridId = useMemo(() => createUUId(true), []);
    const staticDataGridColumns = useMemo<Array<Partial<DataGridColumn>>>(() => [
        ...(operatorAccessLevels.packages.warrantyAndReturn.editRequest ? [
            {
                name: staticColumnsNames.remove,
                alignment: DataGridColumnAlignments.center,
                type: DataGridColumnTypes.element,
                pinned: true,
                sortable: false,
                pinnedToggleable: false,
                resizable: false,
                visibilityToggleable: false,
                width: 0,
            },
        ] : []),
        ...(operatorAccessLevels.packages.warrantyAndReturn.viewDetails ? [
            {
                name: staticColumnsNames.navigate,
                alignment: DataGridColumnAlignments.center,
                type: DataGridColumnTypes.element,
                pinned: true,
                sortable: false,
                pinnedToggleable: false,
                resizable: false,
                visibilityToggleable: false,
                width: 0,
            },
        ] : []),
        ...(operatorAccessLevels.packages.warrantyAndReturn.editRequest ? [
            {
                title: "Accept Request",
                name: staticColumnsNames.accept,
                alignment: DataGridColumnAlignments.center,
                type: DataGridColumnTypes.element,
                sortable: false,
                width: 150,
            },
        ] : []),
        ...((operatorAccessLevels.packages.warrantyAndReturn.viewDetails && operatorAccessLevels.packages.bizPrint.printWarrantyAndReturnClaim) ? [
            {
                name: staticColumnsNames.print,
                alignment: DataGridColumnAlignments.center,
                type: DataGridColumnTypes.element,
                pinned: true,
                sortable: false,
                pinnedToggleable: true,
                resizable: false,
                visibilityToggleable: false,
                width: 0,
            },
        ] : []),
    ], [operatorAccessLevels.packages.warrantyAndReturn.editRequest, operatorAccessLevels.packages.warrantyAndReturn.viewDetails, operatorAccessLevels.packages.bizPrint.printWarrantyAndReturnClaim]);

    const dataGridColumnsConfig = useMemo<Record<string, Partial<DataGridColumn>>>(() => ({
        [knownColumnNames.rga]: {
            width: 80,
            pinned: true,
        },
        [knownColumnNames.note]: {
            width: 400,
        },
        [knownColumnNames.status]: {
            width: 150,
        },
        [knownColumnNames.internalNote]: {
            width: 100,
        },
        [knownColumnNames.type]: {
            width: 60,
        },
        [knownColumnNames.operatorFirstname]: {
            width: 120,
        },
        [knownColumnNames.operatorLastname]: {
            width: 120,
        },
        [knownColumnNames.vendorCreditNumber]: {
            width: 140,
        },
    }), [])

    const [dynamicColumnsLoading, queryBuilderColumns, dataGridColumns] = useDynamicColumns({
        sectionName: dynamicColumnsSectionName,
        staticDataGridColumns: staticDataGridColumns,
        dataGridColumnsConfig: dataGridColumnsConfig,
    });

    const [savedDataGridColumns, dataGridSortBy, dataGridPageSize, dataGridDensity] = useDataGridSavedState({
        columns: dataGridColumns as DataGridColumn[],
        name: dataGridSaveConfig.name,
        version: dataGridSaveConfig.version,
    });

    const initialPaginationInfo = useMemo(() => dataGridPageSize ? {
        ...DefaultPaginationInfo,
        pageSize: dataGridPageSize
    } : DefaultPaginationInfo, [dataGridPageSize])

    /**
     * Fetches the entries from the server based on the user's filters.
     */
    const fetchEntries = useCallback(async (args: UseSearchFunctionArg, forExport: boolean = false): Promise<undefined | ApiResponseDs<any>> => {
        const siftedFilters = QueryBuilderUtils.getApiQueryFromStateQuery(args.filters as any, queryBuilderColumns);
        const forApi = {
            reportingBaseModel: {
                keyword: siftedFilters.keyword,
                filters: siftedFilters.filters ?? [],
            },
            pagination: args.paginationInfo,
            sortBy: args.orderBy ? [{isDesc: args.orderBy.descending, Property: args.orderBy.field,}] : [],
        }
        const response = await Api.reportPartSupportReq(forApi, args.cancelTokenSource?.token);
        if (!isMounted())
            return;
        if (response?.resultFlag && !forExport) {
            setData(response.data?.items ?? []);
            args.setPaginationInfo((prevState) => ({
                ...prevState as SearchDataSettingsPaginationInfo,
                length: response.data?.totalCount ?? 0,
            }));
        }
        if (response?.resultFlag && forExport)
            return response;
    }, [isMounted, queryBuilderColumns])

    /**
     * Searches among the entries based on the filters from the user.
     */
    const search = useCallback<UseSearchFunction>(async (args) => {
        await fetchEntries(args, false);
    }, [fetchEntries]);

    const initialSearchDataSettings = useMemo<SearchDataSettings>(() => ({
        paginationInfo: initialPaginationInfo,
        orderBy: dataGridSortBy as any,
        filters: {},
    }), [initialPaginationInfo, dataGridSortBy]);

    const searchData = useSearch(search, initialSearchDataSettings)
    const {setPaginationInfo} = searchData;

    /**
     * Fetches the entries for exporting purposes from the server based on the user's filters.
     */
    const getExportInfo = useCallback<GetExportInfoFunc>(async () => {
        const _paginationInfo = {
            length: searchData.paginationInfo!.length,
            pageSize: 100,
            currentPage: 1,
        };
        let entries: any[] = [];
        while (searchData.paginationInfo!.length > entries.length) {
            const res = await fetchEntries({...searchData, paginationInfo: _paginationInfo}, true);
            if (!res?.resultFlag)
                return;

            if (!res?.data?.items?.length)
                break;

            entries.push(...res.data.items);
            if (!isMounted())
                return;
            _paginationInfo.currentPage++;
        }
        if (!entries.length)
            return;
        return {
            title: `Part Support Request List`,
            body: entries.map(entry => {
                const res: Record<any, string> = {};
                const keys = Object.keys(entry);
                for (const key of keys) {
                    const column = savedDataGridColumns.find(e => e.name === key);
                    if (!column)
                        continue;
                    const fetchedTitle = typeof column.title === 'function' ? column.title() : column.title;
                    let title: string = typeof fetchedTitle === 'string' ? fetchedTitle : column.name;
                    if (!title) {
                        title = column.name;
                    }
                    switch (key) {
                        case "failedDate":
                        case "installedDate":
                        case "submitDateTime":
                            res[title] = entry[key] ? DateUtils.serverToLocal(entry[key]).format(DateUtils.dateFormat) : entry[key];
                            break;
                        default:
                            res[title] = entry[key];
                            break;
                    }
                }
                return res;
            })
        }
    }, [searchData, fetchEntries, isMounted, savedDataGridColumns])

    /**
     * Fetches the statuses and types of the requests from the server and if the component is mounted, and the api
     * result is successful, then sets the statuses.
     */
    const getStatusesAndTypes = useCallback(async () => {
        setStatusesLoading(true);
        const response = await Api.getPartSupportTypesAndStatuses();
        if (!isMounted()) return;
        if (response?.resultFlag) {
            setStatuses(response.data.statuses);
            setTypes(response.data.types);
        }
        setStatusesLoading(false);
    }, [isMounted])

    /**
     * Fetches the statuses as soon as the component mounts.
     */
    useEffect(() => {
        getStatusesAndTypes().then()
    }, [getStatusesAndTypes])

    /**
     * Fetches the full information of a request from the server.
     */
    const getOldRequestInfo = useCallback(async (requestId: number) => {
        const response = await Api.getPartSupportRequestInformation(requestId);
        if (!isMounted())
            return null;
        if (response?.resultFlag) {
            return response.data;
        }
        return null;
    }, [isMounted])

    /**
     * Sets the newly created request at the top of the request list only if the requestType is not newRequests.
     *
     * edits the status of the request if it existed in the map (since it means that the template was submitted)
     * @param newRequest {any} newly created request
     */
    const onAddSuccess = useCallback((newRequest: OldRequestListEntry) => {
        const request = {
            changeStatusReasonId: newRequest.changeStatusReasonId,
            creditId: newRequest.creditId,
            creditNo: newRequest.creditNo,
            customerId: newRequest.customer?.id,
            customerName: newRequest.customer?.name,
            failedDate: newRequest.failedDate,
            failedMileage: newRequest.failedMileage,
            id: newRequest.id,
            installedDate: newRequest.installedDate,
            installedMileage: newRequest.installedMileage,
            internalNote: newRequest.internalNote,
            invoiceNo: newRequest.invoiceNo,
            lastModifiedDateTime: newRequest.lastModifiedDate,
            make: undefined,
            makeId: undefined,
            modelId: undefined,
            modelTitle: undefined,
            note: newRequest.note,
            operatorFirstname: newRequest.operator?.firstName,
            operatorId: newRequest.operator?.id,
            operatorLastname: newRequest.operator?.lastName,
            partId: undefined,
            partNo: newRequest.partNo,
            reasonTitle: newRequest.statusChangeReason?.title,
            rga: newRequest.rga,
            serialNo: newRequest.serialNo,
            status: newRequest.status,
            statusId: newRequest.statusID,
            submitDateTime: newRequest.submitDateTime,
            type: newRequest.type,
            typeId: newRequest.typeID,
            unSeriliazablePartsCount: newRequest.unSeriliazablePartsCount,
            vendorCreditNumber: newRequest.vendorCreditNumber,
            vendorId: newRequest.vendor?.id,
            vendorName: newRequest.vendor?.name,
            vin: newRequest.vin,
            warehouseCode: newRequest.warehouseCode,
        } as RequestListEntry;
        setData(prevState => {
            const found = prevState?.find(e => e.id === request.id);
            if (found) {
                return prevState?.map(e => e.id === request.id ? {...e, ...request} : e) ?? []
            }
            return [request, ...prevState]
        })
    }, [])

    /**
     * Shows the documentation step of a new request since the request status is incomplete.
     * @param request
     */
    const showRequestTemplateDocumentation = useCallback(async (request: any) => {
        const oldRequest = await getOldRequestInfo(request.id);
        if (!oldRequest)
            return;
        setAddPartSupportReqDialogState({
            open: true,
            currentProcess: AddPartSupportRequestProcessSteps.documentation,
            request: oldRequest,
        })
    }, [getOldRequestInfo])

    /**
     * Sets the properties of the chosen request in the list of requests.
     * @param request           {any} the request to be updated
     * @param newProperties     {any} the properties to be updated
     */
    const setRequestProperty = useCallback((request: {
        id: number
    }, newProperties: Partial<RequestListEntry> = {}) => {
        setData(prevState => prevState?.map(e => e.id === request?.id ? {...e, ...newProperties} : e) ?? [])
    }, [])

    /**
     * Assigns a request to the operator by calling the server api.
     * @param request {any} the request to be assigned to operator
     */
    const acceptRequest = useCallback(async (request: RequestListEntry) => {
        setRequestProperty(request, {accepting: true});
        const response = await Api.assignPartSupportRequestToOperator(request.id);
        if (!isMounted()) return;
        if (response?.resultFlag) {
            setRequestProperty(request, {
                operatorFirstname: operatorInformation?.firstName ?? "",
                operatorLastname: operatorInformation?.lastName ?? "",
                operatorId: operatorInformation?.id ?? "",
                statusId: response.data,
                status: statuses.find(e => e.id === response.data)?.title,
            });
        }
        setRequestProperty(request, {accepting: false});
    }, [isMounted, setRequestProperty, statuses, operatorInformation]);

    /**
     * Removes the vendor from the part support request.
     *
     * @param {any} request the request to remove the vendor from.
     * @param {boolean} removeMessages whether to remove the messages as well.
     */
    const removeVendor = useCallback(async (request: RequestListEntry, removeMessages: boolean = false) => {
        setRequestProperty(request, {removingVendor: true});
        const forApi = {
            partSupportReqId: request.id,
            isChatBeingRemoved: removeMessages
        }
        const response = await Api.removeVendorFromPartSupportRequest(forApi);
        if (!isMounted()) return;
        if (response?.resultFlag) {
            setRequestProperty(request, {
                vendorId: undefined,
                vendorName: undefined,
                vendorEmail: undefined,
                vendorPhone: undefined,
                vendorCode: undefined,
                vendorAccessLink: undefined,
                vendorCreditNumber: undefined,
                vendorCreditId: undefined,
            });
        }
        setRequestProperty(request, {removingVendor: false});
    }, [isMounted, setRequestProperty])

    /**
     * Asks for the user confirmation to decide whether to remove the associated messages as well or not.
     * - in case of a decision, removes the vendor.
     * @param {any} request the request that the op is to be performed on
     */
    const openRemoveConfirmationDialogForVendor = useCallback((request: RequestListEntry) => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Are you sure that you want to remove the selected vendor from this request? If you want to delete
                    it, you can either remove the vendor only or remove it with all its related messages.
                    Note that the assigned vendor credit will also be removed
                </p>
            </div>,
            {
                maxWidth: 'md'
            },
            (confirmed: boolean) => removeVendor(request, confirmed),
            "Remove the Vendor and related messages",
            "Remove the Vendor Only"
        );
    }, [removeVendor])

    /**
     * Removes the warehouse credit from the request.
     *
     * if the response of the api is successful, then updates the list state.
     * @param request
     */
    const removeWarehouseCredit = useCallback(async (request: RequestListEntry) => {
        setRequestProperty(request, {removingCredit: true});
        const forApi = {
            partSupportReqId: request.id,
        }
        const response = await Api.detachPartSupportRequestCredit(forApi);
        if (!isMounted()) return;
        if (response?.resultFlag) {
            setRequestProperty(request, {
                creditId: undefined,
                creditNo: undefined,
            });
        }
        setRequestProperty(request, {removingCredit: false});
    }, [isMounted, setRequestProperty]);

    /**
     * Removes the vendor credit from the request.
     *
     * if the response of the api is successful, then updates the list state.
     * @param request
     */
    const removeVendorCredit = useCallback(async (request: RequestListEntry) => {
        setRequestProperty(request, {removingVendorCredit: true});
        const forApi = {
            partSupportReqId: request.id,
        }
        const response = await Api.detachPartSupportRequestVendorCredit(forApi);
        if (!isMounted()) return;
        setRequestProperty(request, {removingVendorCredit: false});
        if (response?.resultFlag) {
            setRequestProperty(request, {
                vendorCreditNumber: undefined,
                vendorCreditId: undefined,
            });
        }
    }, [isMounted, setRequestProperty]);

    /**
     * Navigates the operator to the single page of the request.
     *
     * if the request's status is initial, then opens the documentation dialog
     */
    const navigateToPartSupportInformationView = useCallback((request: RequestListEntry) => {
        if (request.statusId !== WarrantyAndReturnRequestStatuses.initial) {
            return history.push(routeFunctions.warrantyAndReturn.single(request.id));
        }
        if (!request.customerId && !request.warehouseCode) {
            return ToastService.error({
                title: "No Customer or Warehouse Found",
                message: "The selected request does not belong to any customers or is not warehouse based. Please contact IT support.",
            });
        }
        if (!operatorAccessLevels.packages.warrantyAndReturn.submitRequest) {
            return ToastService.error({
                title: "Access Denied",
                message: "This request requires you to submit documentations for it, that you do not have access to.",
            });
        }
        showRequestTemplateDocumentation(request).then();
    }, [history, operatorAccessLevels.packages.warrantyAndReturn.submitRequest, showRequestTemplateDocumentation]);


    /**
     * Removes the selected request from the list.
     */
    const removeRequest = useCallback(async (request: RequestListEntry) => {
        setRemoving(prevState => [...prevState, request.id]);
        const response = await Api.removeWarrantyAndReturnRequest(request.id);
        if (!isMounted())
            return;
        setRemoving(prevState => prevState.filter(e => e !== request.id));
        if (response?.resultFlag) {
            setData(prevState => prevState?.filter(e => e.id !== request.id) ?? []);
            setPaginationInfo(prevState => ({...prevState!, length: prevState?.length! - 1}));
        }
    }, [isMounted, setPaginationInfo]);

    /**
     * Gets the confirmation from the user to remove the selected request.
     * @param request
     */
    const getRemoveConfirmation = useCallback((request: RequestListEntry) => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Are you sure that you want to remove this request?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (v: boolean) => v && removeRequest(request),
        );
    }, [removeRequest])

    /**
     * Opens the modal for changing the status of the request
     */
    const openChangeRgaDialog = useCallback(async (request: RequestListEntry) => {
        setChangeRga({
            open: true,
            request: {
                id: request.id,
                rga: request.rga,
            },
        })
    }, [])

    /**
     * Opens the modal for changing the status of the request
     * @param {any} request
     */
    const openChangeStatusDialog = useCallback(async (request: RequestListEntry) => {
        setChangeStatus({
            open: true,
            request: {
                statusID: request.statusId,
                id: request.id,
            },
        })
    }, [])

    /**
     * Opens the dialog for changing the vendor status of the request
     * @param {any} request
     */
    const openChangeVendorStatusDialog = useCallback(async (request: RequestListEntry) => {
        setChangeVendorStatus({
            open: true,
            requestId: request.id as any,
            statusId: request.vendorStatusId as any,
        })
    }, [])

    /**
     * Opens the modal for seeing and manipulating the vendor information of the request.
     * @param {any} request
     */
    const openVendorInfoDialog = useCallback(async (request: RequestListEntry) => {
        setVendorInfo({
            open: true,
            request: {
                id: request.id,
                vendorAccessLink: request.vendorAccessLink,
                vendor: {
                    id: request.vendorId,
                    name: request.vendorName,
                    email: request.vendorEmail,
                    phone: request.vendorPhone,
                    code: request.vendorCode,
                },
            },
        })
    }, [])

    /**
     * Adds the assigned vendor information to the request.
     * @param request
     * @param vendor
     */
    const assignVendorToRequest = useCallback((request: RequestListEntry, vendor: NewVendorInfo) => {
        const res: RequestListEntry = {
            ...request,
            vendorId: vendor.vendorInfo.id,
            vendorName: vendor.vendorInfo.name,
            vendorEmail: vendor.vendorInfo.email,
            vendorPhone: vendor.vendorInfo.phone,
            vendorCode: vendor.vendorInfo.code,
            vendorAccessLink: vendor.vendorAccessLink,
        };
        setRequestProperty(request, res);
    }, [setRequestProperty])

    /**
     * Opens the assign vendor to request dialog.
     * @param request
     */
    const openAssignVendorDialog = useCallback(async (request: RequestListEntry) => {
        setAssignVendor({
            open: true,
            request: {
                id: request.id,
                partNo: request.partNo,
            },
            onSelect: (data: NewVendorInfo) => assignVendorToRequest(request, data)
        })
    }, [assignVendorToRequest])

    /**
     * Opens the update request note dialog.
     * @param request
     */
    const openUpdateRequestNoteDialog = useCallback(async (request: any) => {
        const oldRequest = await getOldRequestInfo(request.id);
        if (!oldRequest)
            return;
        setUpdateNote({
            open: true,
            request: oldRequest,
        })
    }, [getOldRequestInfo])

    /**
     * Opens the assign vendor credit to request dialog.
     *
     * if the request does not have a vendor, first shows the assign vendor to request dialog and only upon its
     * completion, proceeds with the vendor credit to request dialog.
     * @param request
     */
    const openConnectToVendorCreditDialog = useCallback(async (request: RequestListEntry) => {
        if (!request?.vendorId) {
            setAssignVendor({
                open: true,
                request: {
                    id: request.id,
                    partNo: request.partNo,
                },
                onSelect: async (data: NewVendorInfo) => {
                    assignVendorToRequest(request, data);
                    setAssignVendorCredit({
                        open: true,
                        request: {
                            id: request.id,
                            customer: {
                                name: request.customerName,
                            },
                        },
                    })
                }
            })
        } else {
            setAssignVendorCredit({
                open: true,
                request: {
                    id: request.id,
                    customer: {
                        name: request.customerName,
                    },
                },
            })
        }
    }, [assignVendorToRequest])

    /**
     * Asks for the user confirmation to decide whether to remove the associated operation or not.
     * - in case of a confirmation, proceeds with the operation.
     *
     * @param {any} request the request that the op is to be performed on
     * @param {function} operation the operation done in the request if confirmed.
     * @param {string} name
     */
    const openRemoveConfirmationDialog = useCallback((request: RequestListEntry, operation: Function, name: string) => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Do you want to remove this {name} from this Part support Request?
                </p>
            </div>,
            {maxWidth: 'sm'},
            (confirm: boolean) => confirm && operation(request),
        );
    }, [])

    /**
     * Opens the assign credit to request dialog.
     */
    const openAssignCreditDialog = useCallback(async (request: RequestListEntry) => {
        let oldRequest = await getOldRequestInfo(request.id);
        if (!oldRequest)
            return;
        setAssignCredit({open: true, request: oldRequest})
    }, [getOldRequestInfo])


    /**
     * Opens the assign credit to request dialog.
     */
    const openChangeOperatorDialog = useCallback(async (request: RequestListEntry) => {
        setChangeOperator({
            open: true,
            operator: request.operatorId ? {
                id: request.operatorId,
                firstName: request.operatorFirstname,
                lastName: request.operatorLastname,
            } as any : null,
            requestId: request.id as any,
        })
    }, [])

    const vendorInfoPopover = useCallback((request: RequestListEntry) => (
        <Popover
            child={(onEnter: Function) => (
                <IconButton
                    className={'mr-2'}
                    color={'secondary'}
                    onPressed={onEnter}>
                    <InfoOutlined className={'icon small'}/>
                </IconButton>
            )}
            popoverChild={(_: any, onLeave: Function) => (
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingInline: 2,
                        maxWidth: '13rem'
                    }}>
                    {/*@ts-ignore*/}
                    <Col xs={12} className={'mx-2 my-2'}>
                        <Button
                            onClick={() => onLeave() || openVendorInfoDialog(request)}
                            color={'secondary'}
                            variant={'text'}
                            className={'w-100'}
                        >
                            View Information
                        </Button>
                    </Col>
                    {/*@ts-ignore*/}
                    <Col xs={12} className={'mx-2 mb-2'}>
                        {
                            operatorAccessLevels.packages.warrantyAndReturn.manageVendor &&
                            <Button
                                onClick={() => onLeave() || openRemoveConfirmationDialogForVendor(request)}
                                disabled={!!request?.removingVendor}
                                color={'error'}
                                variant={'text'}
                                className={'w-100'}
                            >
                                {
                                    !request?.removingVendor
                                        ? "Remove"
                                        : "Removing..."
                                }
                            </Button>
                        }
                    </Col>
                </Box>
            )}
            // @ts-ignore
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            // @ts-ignore
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        />
    ), [operatorAccessLevels.packages.warrantyAndReturn.manageVendor, openVendorInfoDialog, openRemoveConfirmationDialogForVendor])

    const dataGridRows = useMemo<DataGridRow[]>(() => {
        return data?.map(request => {
            const cells: Record<string, any> = {};
            savedDataGridColumns.forEach(column => {
                const beingRemoved = removing.includes(request.id)
                switch (column.name) {
                    case staticColumnsNames.remove: {
                        cells[column.name] = (
                            <IconButton
                                disabled={!request || beingRemoved}
                                color={'secondary'}
                                onPressed={() => getRemoveConfirmation(request)}
                            >
                                {
                                    beingRemoved
                                        ? <CircularProgress size={12}/>
                                        : <Delete className='icon medium remove-icon'/>
                                }
                            </IconButton>
                        )
                        break;
                    }
                    case staticColumnsNames.navigate: {
                        cells[column.name] = (
                            // @ts-ignore
                            <IconButton
                                disabled={!request || beingRemoved}
                                color={'secondary'}
                                {...(request.statusId !== WarrantyAndReturnRequestStatuses.initial) && {
                                    component: Link,
                                    to: routeFunctions.warrantyAndReturn.single(request.id),
                                }}
                                {...(request.statusId === WarrantyAndReturnRequestStatuses.initial) && {
                                    onPressed: () => navigateToPartSupportInformationView(request),
                                }}
                            >
                                <OpenInNew className='icon normal'/>
                            </IconButton>
                        )
                        break;
                    }
                    case staticColumnsNames.accept: {
                        cells[column.name] = (
                            <>
                                {
                                    request[knownColumnNames.statusId as (keyof typeof knownColumnNames)] === WarrantyAndReturnRequestStatuses.waitForOperator
                                        ? <Button
                                            disabled={request.accepting || beingRemoved}
                                            variant={'outlined'}
                                            color={'primary'}
                                            onClick={() => acceptRequest(request)}
                                        >
                                            {
                                                request?.accepting
                                                    ? "Accepting..."
                                                    : "Accept"
                                            }
                                        </Button>
                                        : <div className={'grey-3 d-flex align-items-center justify-content-center'}>
                                            <IconButton
                                                className={'mr-1'}
                                                color={'secondary'}
                                                onPressed={() => openChangeOperatorDialog(request)}>
                                                <Edit className={'icon small'}/>
                                            </IconButton>
                                            <p {...dataGridCellTextProps}>
                                                {
                                                    request[knownColumnNames.statusId as (keyof typeof knownColumnNames)] === WarrantyAndReturnRequestStatuses.initial
                                                        ? "Requires Documents"
                                                        : "Has been accepted"
                                                }
                                            </p>
                                        </div>
                                }
                            </>
                        )
                        break;
                    }
                    case staticColumnsNames.print:
                        cells[column.name] = (
                            <Tooltip title={'Print'} className={'mr-2'}>
                                 <span>
                                     <IconButton
                                         disabled={!request || beingRemoved}
                                         color={'secondary'}
                                         className={'email-icon-container'}
                                         //@ts-ignore
                                         component={Link}
                                         to={routeFunctions.print.partSupport(request.id)}
                                         target={'_blank'}
                                     >
                                        <SvgIcon className='icon medium' component={Printer}/>
                                    </IconButton>
                                </span>
                            </Tooltip>
                        )
                        break;
                    case knownColumnNames.rga: {
                        cells[column.name] = (
                            <>
                                {
                                    operatorAccessLevels.packages.warrantyAndReturn.editRequest &&
                                    <IconButton
                                        className={'mr-2'}
                                        color={'secondary'}
                                        onPressed={() => openChangeRgaDialog(request)}
                                    >
                                        <Edit className={'icon small'}/>
                                    </IconButton>
                                }
                                <p {...dataGridCellTextProps} className={'text-sm'}>
                                    {request[knownColumnNames.rga as (keyof typeof knownColumnNames)] ?? '--'}
                                </p>
                            </>
                        );
                        break;

                    }
                    case knownColumnNames.serialNo: {
                        cells[column.name] = (
                            <>
                                {
                                    !!request[knownColumnNames.serialNo as any] &&
                                    <CopyToClipboard tooltipProps={{}}>
                                        {({copy}) =>
                                            <IconButton
                                                onPressed={() => copy(request[knownColumnNames.serialNo as (keyof typeof knownColumnNames)] ?? '--')}
                                                className={'copy-to-clipboard-button mr-2'}
                                            >
                                                <SvgIcon className={'icon small'} component={Copy}/>
                                            </IconButton>}
                                    </CopyToClipboard>
                                }
                                <p {...dataGridCellTextProps} className={'text-sm'}>
                                    {request[knownColumnNames.serialNo as (keyof typeof knownColumnNames)] ?? '--'}
                                </p>
                            </>
                        );
                        break;

                    }
                    case knownColumnNames.status: {
                        cells[column.name] = (
                            <>
                                {
                                    operatorAccessLevels.packages.warrantyAndReturn.editRequest &&
                                    <IconButton
                                        className={'mr-1'}
                                        color={'secondary'}
                                        onPressed={() => openChangeStatusDialog(request)}>
                                        <Edit className={'icon small'}
                                        />
                                    </IconButton>
                                }
                                <p {...dataGridCellTextProps} className={'text-sm'}>
                                    {request[column.name as (keyof typeof knownColumnNames)] ?? '--'}
                                </p>
                            </>
                        )
                        break;
                    }
                    case knownColumnNames.vendorStatus: {
                        cells[column.name] = (
                            <>
                                {
                                    operatorAccessLevels.packages.warrantyAndReturn.manageVendor &&
                                    <IconButton
                                        className={'mr-1'}
                                        color={'secondary'}
                                        onPressed={() => openChangeVendorStatusDialog(request)}>
                                        <Edit className={'icon small'}
                                        />
                                    </IconButton>
                                }
                                <p {...dataGridCellTextProps} className={'text-sm'}>
                                    {request[column.name as (keyof typeof knownColumnNames)] ?? '--'}
                                </p>
                            </>
                        )
                        break;
                    }
                    case knownColumnNames.partNo: {
                        cells[column.name] = (
                            <ProductInformationPopover partNo={request.partNo}>
                                {request[column.name as (keyof typeof knownColumnNames)] ?? "--"}
                            </ProductInformationPopover>
                        )
                        break;
                    }
                    case knownColumnNames.creditNo: {
                        cells[column.name] = (
                            <>
                                {
                                    !!request[knownColumnNames.customerName as (keyof typeof knownColumnNames)] && request[knownColumnNames.creditNo as (keyof typeof knownColumnNames)] &&
                                    <>
                                        {
                                            operatorAccessLevels.packages.warrantyAndReturn.editRequest &&
                                            <IconButton
                                                onPressed={() => openRemoveConfirmationDialog(request, removeWarehouseCredit, "Credit")}
                                                disabled={request?.removingCredit}
                                                color={'paper.error'}
                                            >
                                                {
                                                    request?.removingCredit
                                                        ? <CircularProgress size={12}/>
                                                        : <Delete className='icon small remove-icon'/>
                                                }

                                            </IconButton>
                                        }
                                        <p {...dataGridCellTextProps} className={'ml-1'}>
                                            {request[knownColumnNames.creditNo as (keyof typeof knownColumnNames)] ?? '--'}
                                        </p>
                                    </>
                                }
                                {
                                    !!request[knownColumnNames.customerName as (keyof typeof knownColumnNames)] && !request[knownColumnNames.creditNo as (keyof typeof knownColumnNames)] &&
                                    operatorAccessLevels.packages.warrantyAndReturn.editRequest &&
                                    <Button
                                        variant={'outlined'}
                                        color={'primary'}
                                        onClick={() => openAssignCreditDialog(request)}
                                    >
                                        Connect
                                    </Button>
                                }
                            </>
                        )
                        break;
                    }
                    case knownColumnNames.vendorCreditNumber: {
                        cells[column.name] = (
                            <>
                                {
                                    request[knownColumnNames.vendorCreditNumber as (keyof typeof knownColumnNames)] &&
                                    <>
                                        {
                                            operatorAccessLevels.packages.warrantyAndReturn.manageVendor &&
                                            <IconButton
                                                onPressed={() => openRemoveConfirmationDialog(request, removeVendorCredit, 'Vendor Credit')}
                                                disabled={request?.removingVendorCredit}
                                                color={'paper.error'}
                                            >
                                                {
                                                    request?.removingVendorCredit
                                                        ? <CircularProgress size={12}/>
                                                        : <Delete className='icon small remove-icon'/>
                                                }

                                            </IconButton>
                                        }
                                        <p {...dataGridCellTextProps}
                                           className={'ml-1'}>{request[knownColumnNames.vendorCreditNumber as (keyof typeof knownColumnNames)] ?? '--'}</p>
                                    </>
                                }
                                {
                                    !request[knownColumnNames.vendorCreditNumber as (keyof typeof knownColumnNames)] &&
                                    operatorAccessLevels.packages.warrantyAndReturn.manageVendor &&
                                    <Button
                                        variant={'outlined'}
                                        color={'primary'}
                                        onClick={() => openConnectToVendorCreditDialog(request)}
                                    >
                                        Connect
                                    </Button>
                                }
                            </>
                        )
                        break;
                    }
                    case knownColumnNames.vendorName: {
                        cells[column.name] = (
                            <>
                                {
                                    !!request[knownColumnNames.vendorName as (keyof typeof knownColumnNames)] &&
                                    <>
                                        {vendorInfoPopover(request)}
                                        <p>{request[knownColumnNames.vendorName as (keyof typeof knownColumnNames)] ?? '--'}</p>
                                    </>
                                }
                                {
                                    !request[knownColumnNames.vendorName as (keyof typeof knownColumnNames)] &&
                                    operatorAccessLevels.packages.warrantyAndReturn.manageVendor &&
                                    <Button
                                        variant={'outlined'}
                                        color={'primary'}
                                        onClick={() => openAssignVendorDialog(request)}
                                    >
                                        Connect
                                    </Button>
                                }
                            </>
                        )
                        break;
                    }
                    case knownColumnNames.vendorCode: {
                        cells[column.name] = (
                            <>
                                {
                                    !!request[knownColumnNames.vendorCode as (keyof typeof knownColumnNames)] &&
                                    <>
                                        {vendorInfoPopover(request)}
                                        <p>{request[knownColumnNames.vendorCode as (keyof typeof knownColumnNames)] ?? '--'}</p>
                                    </>
                                }
                                {
                                    !request[knownColumnNames.vendorCode as (keyof typeof knownColumnNames)] &&
                                    operatorAccessLevels.packages.warrantyAndReturn.manageVendor &&
                                    <Button
                                        variant={'outlined'}
                                        color={'primary'}
                                        onClick={() => openAssignVendorDialog(request)}
                                    >
                                        Connect
                                    </Button>
                                }
                            </>
                        )
                        break;
                    }
                    case knownColumnNames.note: {
                        const length = (request[knownColumnNames.note as (keyof typeof knownColumnNames)]?.toString() ?? "").length;
                        cells[column.name] = (
                            <div>
                                <p {...dataGridCellTextProps} className={'word-line-break-anywhere'}>
                                    {
                                        request[knownColumnNames.note as (keyof typeof knownColumnNames)]
                                            ? request[knownColumnNames.note as (keyof typeof knownColumnNames)]?.toString()?.substring(0, Math.min(160, length))
                                            + (length > 160 ? '...' : '')
                                            : ''
                                    }
                                </p>
                                {
                                    operatorAccessLevels.packages.warrantyAndReturn.editRequest &&
                                    <Button
                                        className={`m-1 d-inline-block`}
                                        variant={'outlined'}
                                        color={'primary'}
                                        onClick={() => openUpdateRequestNoteDialog(request)}
                                    >
                                        {
                                            !!request[knownColumnNames.note as (keyof typeof knownColumnNames)]
                                                ? "View"
                                                : "Create"
                                        }
                                    </Button>
                                }
                            </div>
                        )
                        break;
                    }
                    case knownColumnNames.internalNote: {
                        const length = (request[knownColumnNames.internalNote as (keyof typeof knownColumnNames)]?.toString() ?? "").length;
                        cells[column.name] = (
                            <div>
                                <p {...dataGridCellTextProps} className={'word-line-break-anywhere'}>
                                    {
                                        request[knownColumnNames.internalNote as (keyof typeof knownColumnNames)]
                                            ? request[knownColumnNames.internalNote as (keyof typeof knownColumnNames)]?.toString()?.substring(0, Math.min(40, length))
                                            + (length > 40 ? '...' : '')
                                            : ''
                                    }
                                </p>
                                {
                                    operatorAccessLevels.packages.warrantyAndReturn.editRequest &&
                                    <Button
                                        className={`m-1 d-inline-block`}
                                        variant={'outlined'}
                                        color={'primary'}
                                        onClick={() => openUpdateRequestNoteDialog(request)}
                                    >
                                        {
                                            !!request[knownColumnNames.internalNote as (keyof typeof knownColumnNames)]
                                                ? "View"
                                                : "Create"
                                        }
                                    </Button>
                                }
                            </div>
                        )
                        break;
                    }
                    case knownColumnNames.customerName: {
                        cells[column.name] = request[knownColumnNames.customerName as keyof typeof request] ?? 'Warehouse Based';
                        break
                    }
                    default:
                        cells[column.name] = request[column.name as keyof typeof request];
                        break;
                }
            })
            return {
                key: request.id,
                data: request,
                cells: cells,
            }
        });
    }, [data, savedDataGridColumns, removing, getRemoveConfirmation, navigateToPartSupportInformationView, acceptRequest, openChangeOperatorDialog, operatorAccessLevels.packages.warrantyAndReturn.editRequest, operatorAccessLevels.packages.warrantyAndReturn.manageVendor, openChangeRgaDialog, openChangeStatusDialog, openChangeVendorStatusDialog, openRemoveConfirmationDialog, removeWarehouseCredit, openAssignCreditDialog, removeVendorCredit, openConnectToVendorCreditDialog, vendorInfoPopover, openAssignVendorDialog, openUpdateRequestNoteDialog])

    /**
     * Closes the add part support request dialog.
     */
    const closeAddPartSupportReqDialog = useCallback(() => setAddPartSupportReqDialogState(initAddPartSupportReqDialogState), [])

    return (
        <>
            {
                dynamicColumnsLoading &&
                <>
                    <LoadingLottieAnimation
                        width={'50%'}
                        className={'my-5'}
                    />
                </>
            }
            {
                !dynamicColumnsLoading &&
                <>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Typography variant={'subtitle1'} fontWeight={600}>
                            Part Support Requests List
                        </Typography>
                        {
                            operatorAccessLevels.packages.warrantyAndReturn.submitRequest &&
                            <Button
                                className={'mr-2 d-flex align-items-center justify-content-center'}
                                variant={'outlined'}
                                color={'primary'}
                                onClick={() => setAddPartSupportReqDialogState({
                                    open: true,
                                    request: undefined,
                                    currentProcess: null,
                                })}
                            >
                                <Add className={`icon small`} style={{margin: '2px 0'}}/>
                                <p className='ml-2'>Add new</p>
                            </Button>
                        }
                    </Box>
                    <QueryBuilder
                        columns={queryBuilderColumns}
                        name={queryBuilderSaveName}
                        search={searchData.setFilters as any}
                        query={searchData.filters as any}
                        loading={searchData.loading}
                        dataGridId={dataGridId}
                    />
                    <div className='w-100 my-5'/>
                    {/*@ts-ignore*/}
                    <PartnerDataGrid
                        id={dataGridId}
                        {...dataGridSaveConfig}
                        initialLayoutState={{columns: dataGridColumns as DataGridColumn[]}}
                        columns={savedDataGridColumns}
                        rows={dataGridRows}
                        hideFooterActions
                        state={{
                            sortBy: searchData.orderBy,
                            pagination: searchData.paginationInfo,
                            loading: {state: searchData.loading} as any,
                            density: dataGridDensity,
                        }}
                        getExportInfo={canExportPartSupportRequests ? getExportInfo : undefined}
                        onSortByChanged={(_, current) =>
                            searchData.setOrderBy?.(current)}
                        onCurrentPageChanged={(_, current) =>
                            searchData.setPaginationInfo(prevState => ({...prevState as SearchDataSettingsPaginationInfo, ...current}))}
                        onPageSizeChanged={(_, current) =>
                            searchData.setPaginationInfo(prevState => ({...prevState as SearchDataSettingsPaginationInfo, ...current}))}
                    />
                </>
            }
            <UpsertPartSupportStatusDialog
                statuses={statuses}
                request={changeStatus.request}
                setOpen={() => setChangeStatus(initialChangeStatus)}
                open={changeStatus.open}
                onSuccess={(request: OldRequestListEntry, status: Status, reason?: StatusReason) => {
                    setRequestProperty(request, {
                        statusId: status.id,
                        status: status.title,
                        changeStatusReasonId: reason?.id,
                        reasonTitle: reason?.title,
                    })
                }}
            />
            <UpsertPartSupportVendorStatusDialog
                open={changeVendorStatus.open}
                setOpen={(open: boolean, anyStatusesRemoved: boolean) => {
                    setChangeVendorStatus(initialChangeVendorStatus)
                    if (anyStatusesRemoved) {
                        searchData.setLoading?.(true);
                        search(searchData).then(() => {
                            if (!isMounted())
                                return;
                            searchData.setLoading?.(false);
                        })
                    }
                }}
                requestId={changeVendorStatus.requestId}
                statusId={changeVendorStatus.statusId}
                onSuccess={(requestId: number, status: Status, reason?: StatusReason) => setRequestProperty({id: requestId}, {
                    vendorStatusId: status.id,
                    vendorStatus: status.title,
                    vendorStatusReasonId: reason?.id,
                    vendorStatusReason: reason?.title,
                })}
            />
            <ChangeWarrantyRGAModal
                request={changeRga.request}
                setOpen={() => setChangeRga(initialChangeRga)}
                open={changeRga.open}
                onSuccess={(request: OldRequestListEntry, rga: string) =>
                    setRequestProperty(request, {
                        rga: rga,
                    })}
            />
            <AssignCreditToPartSupportRequestModal
                partSupportRequest={assignCredit.request}
                open={assignCredit.open}
                setOpen={() => setAssignCredit(initialAssignCredit)}
                onSuccess={(request: OldRequestListEntry, data: any) =>
                    setRequestProperty(request, {
                        creditId: data.creditId,
                        warehouseCode: data.warehouseCode,
                        creditNo: data.creditNo,
                    })}
            />
            <AssignVendorCreditToPartSupportRequestModal
                request={assignVendorCredit.request}
                open={assignVendorCredit.open}
                setOpen={() => setAssignVendorCredit(initialAssignVendorCredit)}
                onSuccess={(request: OldRequestListEntry, data: any) =>
                    setRequestProperty(request, {
                        vendorCreditNumber: data.purchaseNo,
                        vendorCreditId: data.id,
                    })}
            />
            <UpdatePartSupportRequestNoteModal
                request={updateNote.request}
                open={updateNote.open}
                setOpen={() => setUpdateNote(initialUpdateNote)}
                onSuccess={(request: OldRequestListEntry, note: string, internalNote: string) =>
                    setRequestProperty(request, {
                        note: note,
                        internalNote: internalNote
                    })}
            />
            <VendorInformationModal
                request={vendorInfo.request}
                vendor={vendorInfo.request?.vendor}
                open={vendorInfo.open}
                setOpen={() => setVendorInfo(initialVendorInfo)}
                setNewLink={(request: OldRequestListEntry, newLink: string) =>
                    setRequestProperty(request, {
                        vendorAccessLink: newLink
                    })}
            />
            <ChangePartSupportOperatorDialog
                open={changeOperator.open}
                setOpen={() => setChangeOperator(initialChangeOperator)}
                operator={changeOperator.operator}
                requestId={changeOperator.requestId}
                onSuccess={(requestId: number, operator: any) => setRequestProperty({id: requestId}, {
                    operatorId: operator.id,
                    operatorFirstname: operator.firstName,
                    operatorLastname: operator.lastName,
                })}
            />
            <PartSupportVendorSelection
                dialog
                request={assignVendor.request}
                onSelect={assignVendor.onSelect}
                open={assignVendor.open}
                setOpen={() => setAssignVendor(initialAssignVendor)}
            />
            <AddPartSupportRequestDialog
                open={addPartSupportReqDialogState.open}
                request={addPartSupportReqDialogState.request}
                currentProcess={addPartSupportReqDialogState.currentProcess as string}
                types={types}
                loadingTypes={statusesLoading}
                setOpen={closeAddPartSupportReqDialog}
                onSuccess={onAddSuccess}
            />
        </>
    )
}

export default PartSupportRequestListView;
